<template>
  <div>
    <van-nav-bar title="领取体验金" left-text="返回" left-arrow @click-left="goHome" />

    <div class="page-container">
      <img class="bg" :src="bgPoster" alt="">
      <div class="content" v-if="detail.status === 1">
        <div class="price">
          <div class="left">面额：</div>
          <div class="right">{{ detail.rebate }}</div>
        </div>
        <div class="title">{{ detail.name }}</div>
        <div class="tips"> 领取号码：{{ userInfo.phone }} </div>
        <div class="btn-box">
          <button class="btn confirm" v-if="detail.status === 1 && !isReceive" @click="onReceive">立即领取</button>
          <button class="btn cancel" v-else @click="goHome">已领取，去使用</button>
        </div>
      </div>
      <div class="content" v-else>
        <div class="tips">您来晚了，链接已失效。</div>
        <div class="btn-box">
          <button class="btn cancel" @click="goHome">关闭</button>
        </div>
      </div>
    </div>

    <popup-message ref="PopupMessageRef"></popup-message>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixin from './mixin/index'

import { NavBar } from 'vant'
import PopupMessage from './components/PopupMessage.vue'
import bgPoster from './images/bg-poster.js'

export default {
  name: 'EGReceive',
  mixins: [mixin],
  components: {
    VanNavBar: NavBar,
    PopupMessage
  },
  data () {
    return {
      bgPoster,
      isReceive: false
    }
  },
  computed: {
    ...mapState('store', ['userInfo'])
  },
  watch: {},
  created () {},
  methods: {
    goHome () {
      this.$router.push('home')
    },
    async onReceive () {
      this.$toast.loading()
      const payload = {
        code: this.code
      }
      const res = await this.$axios.post('api/member/account_experience_gift_get', payload)
      this.$toast.clear()
      const { code, msg } = res.data
      if (code === 0) {
        this.isReceive = true
        this.$refs.PopupMessageRef.open({
          title: '领取成功',
          message: '点击“去使用”到平台首页-体验专区使用吧！',
          confirmText: '去使用',
          cancelText: '知道了',
          confirmFn: (done) => {
            this.goHome()
            done()
          }
        })
      } else {
        this.$refs.PopupMessageRef.open({
          title: '领取失败',
          message: msg,
          confirmText: '知道了',
          cancelShow: false
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

/deep/ .van-nav-bar  {
  .van-nav-bar__text {
    color: #404040;
  }
  .van-icon {
    color: #b2b2b2;
  }
}

.page-container {
  width: 100%;
  position: relative;

  .content {
    width: 6.68rem;
    height: 8.48rem;
    background: #ffffff;
    margin: 0.70rem 0 0;
    text-align: center;
    overflow: hidden;
    position: absolute;
    top: 2.76rem;
    left: 0;
    right: 0;
    margin: auto;

    .price {
      margin-top: 0.60rem;
      .flex-center;
      align-items: flex-end;

      .left {
        margin-bottom: 0.10rem;
        font-size: 0.22rem;
        color: #626262;
      }
      .right {
        font-size: 0.50rem;
        color: #F96D09;
      }
    }
    .title {
      margin-top: 0.30rem;
      font-size: 0.28rem;
      font-weight: bold;
      color: #464646;
    }
    .tips {
      margin-top: 0.70rem;
      font-size: 0.24rem;
      color: #353535;
      line-height: 2em;
    }
    .btn-box {
      margin-top: 0.70rem;

      .btn {
        display: block;
        width: 5.00rem;
        height: 0.72rem;
        margin: 0 auto 0.32rem;
        border-radius: 999rem;
        font-size: 0.26rem;

        &.confirm {
          background: #F96D09;
          color: #ffffff;
        }
        &.cancel {
          border: 0.01rem solid #268CFF;
          color: #268CFF;
        }
      }
    }
  }
}
</style>
